import { gql, useMutation, useQuery } from '@apollo/client';
import { useToast } from 'components/ui/toast';
import {
	EvolveSettingsUpdate,
	Mutation,
	MutationUpdateEvolveSettingsArgs,
	Query,
} from 'middleware-types';
import { handleNoResponse, responseHasErrors } from 'utils/errors';

export const EVOLVE_SETTINGS = gql`
	query evolveSettings {
		evolveSettings {
			isLegacyUiInMaintenanceMode
			legacyUiInMaintenanceModeMessage
			id
		}
	}
`;

export const useEvolveSettings = () => {
	const { data, loading } = useQuery<Pick<Query, 'evolveSettings'>>(EVOLVE_SETTINGS, {
		fetchPolicy: 'cache-and-network',
		onError: (error) => console.log(error),
	});

	return {
		evolveSettings: data?.evolveSettings,
		loading,
	};
};

const UPDATE_EVOLVE_SETTINGS = gql`
	mutation updateEvolveSettings($settingsId: ID!, $update: EvolveSettingsUpdate!) {
		updateEvolveSettings(settingsId: $settingsId, update: $update)
	}
`;

export const useUpdateEvolveSettings = () => {
	const toast = useToast();

	const [_updateEvolveSettings] = useMutation<
		Pick<Mutation, 'updateEvolveSettings'>,
		MutationUpdateEvolveSettingsArgs
	>(UPDATE_EVOLVE_SETTINGS);

	const updateEvolveSettings = async (settingsId: string, update: EvolveSettingsUpdate) => {
		return await _updateEvolveSettings({
			variables: { settingsId, update },
			onError: (error) => console.log(error),
			update: (cache) => {
				cache.evict({
					id: 'ROOT_QUERY',
					fieldName: 'evolveSettings',
				});
			},
		})
			.then((res) => {
				if (responseHasErrors(res.errors, { toast })) {
					return false;
				}
				toast.push('Evolve settings updated successfully.', { variant: 'success' });
				return true;
			})
			.catch(() => {
				handleNoResponse({ toast });
				return false;
			});
	};

	return { updateEvolveSettings };
};
